import React, { Component } from 'react'

import utils from '../utils'
const { analysisBusinessFlag, priceFormat, FE } = utils

export default class GoodsItem extends Component {
  render(){
    let { goods, city, cityName, minPrice, pvId } = this.props,isVoucher,
    localIconStyle = goods.pickCityIds.indexOf(parseInt(city/100)) > -1?'car-icon1':'car-icon1 fn-hide',
    flags = {
      red: analysisBusinessFlag(goods.businessFlag.businessFlag,1),
      cx: analysisBusinessFlag(goods.businessFlag.businessFlag,6)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,7)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,8)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,11)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,12)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,14)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,15)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,16)
       || analysisBusinessFlag(goods.businessFlag.businessFlag,17)
    },
    itemUrl = FE.Utils.getHref(`${goods.mDetailUrl}#pvareaid=${pvId}`)

    if (goods.source === 18) {
      // 抵扣券
      isVoucher = true
    } else if (goods.source === 1 || goods.source === 12 || goods.source === 17) {
      // 一口价
      isVoucher = false
    }

    return(
      <a href={itemUrl} className='goods-item'>
        <div className='car-box'>
          <span className={localIconStyle}>{`${cityName}提车`}</span>
          <img src={goods.picUrl} alt='' />
        </div>
        <div className='goods-info'>
          <p className={goods.carSourceType !== 0 && goods.carSourceType !== 3?'car-name car-name--isYX':'car-name'}>{goods.name}</p>
          <p className='car-ad'>{goods.slogan}</p>
          <div className='car-price-wrap'>
            {
              goods.priceTitle ?
                <p className='car-price'>{goods.priceTitle}</p>
                :
                isVoucher?
                  <p className='car-price'>{`${goods.price}元抵扣${goods.worth}元权益`}</p>
                  :
                  <p className='car-price'><span>{priceFormat(minPrice)}</span>万</p>
            }
            <p className={flags.red?'car-icon2':'car-icon2 fn-hide'}></p>
            <p className={flags.cx?'car-icon3':'car-icon3 fn-hide'}></p>
          </div>
        </div>
      </a>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/GoodsItem.js